module.exports = __webpack_public_path__ + "static/media/non-binary-and-trans.4f7f69d6.png";